import { Serializable } from '@core/models';
import { PrintMenuTheme } from './printMenuTheme';
import { PrintMenuSection } from './printMenuSection';
import { PrintMenuProduct } from './printMenuProduct';
import { PrintMenuCurrency } from './printMenuCurrency';
import { PrintMenuConfiguration } from './printMenuConfiguration';

export class PrintMenu extends Serializable {
  menuLanguage = null;

  constructor(guid, title, pointOfSaleLogo, theme, sections, features, currency, configuration, informationText) {
    super();
    this.guid = guid;
    this.title = title;
    this.pointOfSaleLogo = pointOfSaleLogo;
    this.theme = theme;
    this.sections = sections;
    this.features = features;
    this.currency = currency;
    this.configuration = configuration;
    this.informationText = informationText;
  }

  serialize() {
    return {};
  }

  headHtml() {
    return `
    <head>
        ${this.theme.fontHeadLinks()}
        <title>${this.title}</title>
    </head>
    `;
  }

  bodyHtml() {
    let html = `
        ${!this.configuration.repeatLogoPerPage ? `<div style="display: flex; justify-content: center;">
            <img style="width: auto; height: auto;" alt="${this.title}" src="${this.pointOfSaleLogo}">
        </div>` : ''}
    `;
    for (let i = 0; i < this.sections.length; i++) {
      const section = this.sections[i];
      html += section.formatForHtml();
      if (section.type === 1 && i < this.sections.length - 1) {
        html += '<div style="page-break-after: always;"></div>';
      }
    }
    if (this.configuration.showProductFeature) {
      html += this.footerHtml();
    }
    return html;
  }

  stylesHtml() {
    return this.theme.addStyles();
  }

  featureHtml(feature) {
    return `
      <div style="flex-basis: 20%; color: white; display: flex; align-items: center; padding: 1px 1px 20px; justify-content: center">
        <img style="height: 35px; width: 35px;" src="${feature.image}" >
        <div style="margin-left: 5px; width: 40%;">${feature.name}</div>
      </div>`;
  }

  footerHtml() {
    return `
        <div style="background-color: rgb(34, 34, 34); display: flex; flex-flow: row wrap; justify-content: center; page-break-inside: avoid; margin-top: 25px;">
            ${this.menuLanguage && `<h3 style="color: white; width: 100%; text-align: center;">${this.menuLanguage.featureText}</h3>`}
            ${this.features.map((feature) => this.featureHtml(feature)).join('')}
        </div>
    `;
  }

  serializeHtml() {
    PrintMenuProduct.printCurrency = this.currency;
    PrintMenuProduct.configuration = this.configuration;
    PrintMenuSection.configuration = this.configuration;
    PrintMenuSection.theme = this.theme;
    PrintMenuTheme.configuration = this.configuration;
    const printBackgroundHtml = '<div class="no-print background-print"></div>';

    let informationTextHeader = '';
    if (this.configuration.showInformationText) {
      if (this.informationText) {
        informationTextHeader = `<div class="disclaimer">${this.informationText}</div>`;
      }
    }

    return `
      ${this.headHtml()}
      ${this.stylesHtml()}
      ${printBackgroundHtml}
      <table>
        <thead>
          <tr>
            <td>
                <div class="container-header">
                    ${this.configuration.repeatLogoPerPage ? `<img style="width: 200px; height: auto; margin: auto;" alt="${this.title}" src="${this.pointOfSaleLogo}">` : ''}
                    ${informationTextHeader}
                </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
              <td><div class="content">${this.bodyHtml()}</div></td>
          </tr>
        </tbody>
        <tfoot>
            <tr><td><div class="footer-section"></div></td></tr>
        </tfoot>
      </table>
    `;
  }

  printWindow(windowRef) {
    if (windowRef && !windowRef.closed) {
      const serializedHtml = this.serializeHtml();
      windowRef.document.write(serializedHtml);
      setTimeout(() => {
        windowRef.print();
        windowRef.close();
      }, 200);
    }
  }

  static toInstance(props = {}) {
    const theme = PrintMenuTheme.toInstance(props.theme);
    const sections = PrintMenuSection.toInstanceList(props.sections);
    const currency = PrintMenuCurrency.toInstance(props.currency);
    const menuPrintConfig = PrintMenuConfiguration.toInstance(props.print_menu_configuration);
    return new PrintMenu(props.guid, props.title, props.point_of_sale_logo, theme, sections, props.features, currency, menuPrintConfig, props.information_text);
  }
}
